var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5L5 7.71429V16.3095C5 19.5063 8.71875 21.7381 12 24C15.2812 21.7381 19 19.5063 19 16.3095V7.71429L12 5ZM9.10834 10.1954C9.24079 10.1821 9.37152 10.2316 9.46381 10.3297L12 12.9521L14.5362 10.3297C14.6037 10.2572 14.6926 10.2095 14.7891 10.1954C14.9779 10.1671 15.1634 10.2687 15.2462 10.4463C15.3291 10.6248 15.2907 10.8377 15.1514 10.9729L12.6152 13.5954L15.1514 16.2106C15.2369 16.2945 15.2856 16.4102 15.2873 16.5313C15.289 16.6532 15.2437 16.7699 15.1608 16.8565C15.0779 16.943 14.9651 16.9916 14.8481 16.9908C14.7301 16.9908 14.6182 16.9413 14.5362 16.8538L12 14.2313L9.46379 16.8538C9.38175 16.9413 9.26982 16.9908 9.15189 16.9908C9.03483 16.9916 8.92203 16.943 8.83915 16.8565C8.75626 16.7699 8.71097 16.6532 8.71268 16.5313C8.71439 16.4103 8.7631 16.2945 8.84855 16.2106L11.3847 13.5954L8.84855 10.9729C8.72464 10.851 8.68107 10.6654 8.73746 10.4975C8.793 10.3305 8.93827 10.2122 9.10831 10.1954H9.10834Z",
    fill: "#DCDEE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpam);
export default __webpack_public_path__ + "static/media/spam.4ac25d14162da913b9f5a2165027fc5e.svg";
export { ForwardRef as ReactComponent };